import { render, staticRenderFns } from "./PlotConfigurator.vue?vue&type=template&id=9a89ec90&scoped=true&"
import script from "./PlotConfigurator.vue?vue&type=script&lang=ts&"
export * from "./PlotConfigurator.vue?vue&type=script&lang=ts&"
import style0 from "./PlotConfigurator.vue?vue&type=style&index=0&id=9a89ec90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a89ec90",
  null
  
)

export default component.exports